import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">最近更新</h2>
            <p className="text-sm text-foreground-500 mt-2">最新章节实时更新，追更不等待</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 divide-y divide-background-200/60">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.title === '斗破苍穹' ? 'doupo-cangqiong' : item.title === '一人之下' ? 'yirenzhixia' : 'manhua-trend-2026'}`}
              className="flex items-center gap-4 p-4 hover:bg-background-100 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-16 rounded-md overflow-hidden flex-shrink-0">
                <img src={item.cover} alt={item.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h4>
                <p className="text-xs text-foreground-600 mt-0.5 truncate">{item.chapter}</p>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
              <span className="hidden sm:inline-flex items-center gap-1 px-3 py-1.5 bg-primary-500 text-white text-xs rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap">
                阅读 <i className="ri-arrow-right-s-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}